import { render, staticRenderFns } from "./ContentIcon.vue?vue&type=template&id=4348cd48&"
import script from "./ContentIcon.vue?vue&type=script&lang=js&"
export * from "./ContentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports